export type companyModel = {
  brands: string[];
  coupon: string;
  favicon: string;
  favtitle: string;
  icn: string[];
  image: string;
  intropopup: string;
  link: string[];
  name: string[];
  ordertitle: string;
  orderbutton: string;
  phototitle: string;
  photorequired: string;
};

export type companyParams = {
  [key: string]: companyModel;
};

export const company_menu = ['홈페이지', '접수상담', '이용가이드', 'FAQ'];

// const companyData: {
//   [key: string]: companyParms;
// } = require('./json/offline_oem_company.json');

// export const companyInfo = (name: string): any => {
//   return companyData[name];
// };
